import React from 'react'
import ExchangeForm from '../exchange-form/exchange-form'

const Exchange = () => {
  return <ExchangeForm />
}

export default Exchange